import { IGetPageRes } from '../domains/PagesApi/interfaces/response'

const pageSerializer = (page: IGetPageRes) => {
  const { init_state } = page

  return init_state
}

export default pageSerializer
